<div class="drawer-container" [ngClass]="{ 'open': open }">
    <div class="drawer">
      <ng-content></ng-content>
    </div>
</div>
